import { actions as notificationActions } from '../../actions/common/site_notifications';

export default function siteNotifications( initialState = {}, action ) {
    const newState = { ...initialState };

    switch (action.type) {
        case notificationActions.GET_NOTIFICATIONS_REQ: return notificationsReducer( newState, action );
        case notificationActions.GET_NOTIFICATIONS_SUCCESS: return notificationsReducer( newState, action );
        case notificationActions.GET_NOTIFICATIONS_ERROR: return notificationsReducer( newState, action );
        case notificationActions.UPDATE_NOTIFICATION_REQ: return notificationsReducer( newState, action );
        case notificationActions.UPDATE_NOTIFICATION_SUCCESS: return notificationsReducer( newState, action );
        case notificationActions.UPDATE_NOTIFICATION_ERROR: return notificationsReducer( newState, action );
        default: return newState;
    }
}

function notificationsReducer( newState, action ) {
    const copy = {...action};
    delete copy.type;
    
    newState = copy;

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/common/site_notifications.js